import { render, staticRenderFns } from "./CartItemMobile.vue?vue&type=template&id=177374d8"
import script from "./CartItemMobile.vue?vue&type=script&lang=js"
export * from "./CartItemMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports